import { cloneDeep } from 'lodash';

export const mergeExtractionFields = (nextSelectedExtract, selectedExtract) => {
  return Object.values(
    [...nextSelectedExtract, ...selectedExtract].reduce((acc, item) => {
      if (!acc[item.id]) acc[item.id] = item;
      return acc;
    }, {})
  );
};

export const computeCustomFields = (data, category) => {
  if (!data) return [];

  const fields = cloneDeep(data);

  for (let i = 0; i < fields?.length; i++) {
    for (let j = 0; j < category?.tables?.length; j++) {
      if (category.tables[j]?.name === fields[i]?.table) {
        for (let k = 0; k < category.tables[j].columns?.length; k++) {
          const column = category.tables[j].columns[k];
          if (column?.name === fields[i]?.name) {
            fields[i].isEmpty = column?.isEmpty;
          }
        }
      }
    }
  }

  return fields;
};

export const getRequiredFields = category => {
  return category?.tables
    ?.map(item => item.columns)
    ?.flat()
    ?.filter(item => !item.is_custom);
};

export const getFieldBorderColor = (isSelected, isEmpty) => {
  if (isSelected) return '#228BE6';
  if (isEmpty) return '#CED4DA';
  return '#E7F5FF';
};

export const getFieldBackgroundColor = isEmpty => {
  return isEmpty ? 'white' : 'blue.0';
};

export const getFieldTextColor = (isSelected, isEmpty) => {
  if (isSelected) return 'blue.6';
  if (isEmpty) return 'black';
  return 'blue.6';
};

export const getFieldIconColor = (isSelected, isEmpty) => {
  if (isSelected) return '#228BE6';
  if (isEmpty) return '#868E96';
  return '#228BE6';
};

export const isFieldSelected = (selectedExtract, field, tableName = null) => {
  return !!selectedExtract.find(value => {
    const idMatch = (value.uuid || value.id) === (field.uuid || field.id);
    if (tableName && field.table) {
      return idMatch && value.table === field.table;
    }
    return idMatch;
  });
};

export const areAllFieldsSelected = (selectedExtract, requiredFields, customFields) => {
  const totalFields = (requiredFields?.length || 0) + (customFields?.length || 0);
  return selectedExtract.length === totalFields;
};

export const shouldShowRemapButton = (requiredFields, customFields) => {
  return !![...(requiredFields || []), ...(customFields || [])].find(el => !el.isEmpty);
};
